import React, { FC, useState, useEffect, useContext } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Layout } from 'antd'
import { MiscellaneousStats } from './components/MiscellaneousStats'
import { fetchActiveTournament, fetchTournamentMatches } from './services/PubgService'
import { Tournament } from './models/Tournament'
import { PennyVibes } from './components/PennyVibes'
import { Info } from './components/Info'
import { Match } from './models/Match'
import { LeaderboardStats } from './components/LeaderboardStats'
import { Awards } from './components/Awards'
import { matchTotal } from './services/StatAggregatorService'
import { PointSystem } from './models/leaderboards/PointSystem'
import { PastTournamentComponent } from './components/history/PastTournamentComponent'
import { BonusComponent } from './components/bonus/BonusComponent'
import { Twitch } from './components/twitch/TwitchComponent'
import { MenuComponent } from './components/menu/MenuComponent'
import { TournamentContext } from './App'

const { Content, Sider } = Layout

export const Main: FC = () => {
    const [tournament, setTournament] = useState<Tournament>()
    const [matches, setMatches] = useState<Array<Match>>([])
    const [bonusMatches, setBonusMatches] = useState<Array<Match>>()
    const [bonus, setBonus] = useState<boolean>(false)
    const [bounties, setBounties] = useState<Array<string>>([])
    const [totalStats, setTotalStats] = useState<Array<any>>([])
    const [completed, setCompleted] = useState<boolean>(false)
    const [pointSystem, setPointSystem] = useState<PointSystem>()

    const tournamentContext = useContext(TournamentContext)

    const pennyVibes = true

    useEffect(() => {
        loadTournament()
    }, [])

    async function loadTournament() {
        const tournament = await fetchActiveTournament()
        setTournament(tournament)
        tournamentContext.tournamentCompleted = tournament.completed
        setCompleted(tournament.completed)
        setBounties(tournament.bounties.split(","))
        setPointSystem(tournament.placement)
        const matches = await fetchTournamentMatches(tournament.tournamentid)
        const regularMatches = matches.filter((match) => { return match.type !== "Bonus" })
        const bonusMatches = matches.filter((match) => { return match.type === "Bonus" })
        if (bonusMatches.length > 0) {
            tournamentContext.bonusCompleted = true
            setBonus(true)
            setBonusMatches(bonusMatches)
        }

        setMatches(regularMatches)
        setTotalStats(matchTotal(regularMatches))
    }

    return (
        <Layout>
            <Sider style={{ overflow: 'auto', height: 'calc(100vh - 134px)' }} collapsible={true} defaultCollapsed={true} className="hiddenOnMobile">
                <MenuComponent completed={completed} bonus={bonus} />
            </Sider>
            <Switch>
                <Route path="/miscellaneous">
                    <Content className="mainContent">
                        {pennyVibes && <PennyVibes />}
                        {completed && !!tournament && <MiscellaneousStats matches={matches} totalStats={totalStats} />}
                    </Content>
                </Route>
                <Route path="/leaderboards">
                    <Content className="mainContent">
                        {pennyVibes && <PennyVibes />}
                        <LeaderboardStats pointSystem={pointSystem} matches={matches} />
                    </Content>
                </Route>
                <Route path="/stream">
                    <Content className="mainContent">
                        {pennyVibes && <PennyVibes />}
                        <Twitch />
                    </Content>
                </Route>
                <Route path="/awards">
                    <Content className="mainContent">
                        {pennyVibes && <PennyVibes />}
                        {completed && !!tournament && <Awards bounties={bounties} matches={matches} stats={totalStats} pointSystem={pointSystem} />}
                    </Content>
                </Route>
                <Route path="/history/:id">
                    <Content className="mainContent">
                        {pennyVibes && <PennyVibes />}
                        <PastTournamentComponent />
                    </Content>
                </Route>
                <Route exact path="/history">
                    <Content className="mainContent">
                        {pennyVibes && <PennyVibes />}
                        <PastTournamentComponent />
                    </Content>
                </Route>
                <Route path="/bonus">
                    <Content className="mainContent">
                        {pennyVibes && <PennyVibes />}
                        {bonus && <BonusComponent bonusMatches={bonusMatches} pointSystem={pointSystem} />}
                    </Content>
                </Route>
                <Route path="/">
                    <Content className="mainContent">
                        {pennyVibes && <PennyVibes />}
                        <Info tournament={tournament} />
                    </Content>
                </Route>
            </Switch>
        </Layout>
    )
}

export default Main;